import Image from "next/image";
import Link from "next/link";

import EventContent from "./Event-Section/EventContent";
import EventDescription from "./Event-Section/EventDescription";
import EventFaq from "./Event-Section/EventFaq";
import EventParticipants from "./Event-Section/EventParticipants";
import SimilarEvent from "./Event-Section/SimilarEvent";
import EventViedo from "./Event-Section/EventViedo";
import { MDXRemote } from 'next-mdx-remote'
import ImageSourceCaption from "../Media/ImageSourceCaption";
import GoogleAdLarge from "../Ads/GoogleAdLarge";
import LinkButton from "../Buttons/LinkButton";
import SplitTwo from "../Split/Split-Two";
import PastEvents from "./PastEvents";
import DisqusComments from "../Common/DisqusComments";
import { DateTime } from 'luxon';
import LinkButtonSliding from "../Buttons/LinkButtonSliding";

const EventDetails = ({ getMatchEvent, eventContent }) => {
  // console.log(getMatchEvent.past_events)
  return (
    <>
      <div className="row g-5">
        <div className="col-lg-8">
          <div className="course-details-content">
            <div className="rbt-feature-box rbt-shadow-box thuumbnail">
              <Image
                className="w-100"
                src={getMatchEvent.image.poster}
                width={800}
                height={550}
                priority
                alt="Card image"
              />
              <ImageSourceCaption sourceText={getMatchEvent.image.source} />
            </div>
            <div className="rbt-feature-box rbt-shadow-box">
              {/* <EventContent getEventData={getMatchEvent}  /> */}
              <MDXRemote {...eventContent} />

              {/* <div className="buy-now-btn">
                <Link
                  className="rbt-btn btn-gradient icon-hover w-50 text-center"
                  href={getMatchEvent.external_url}
                  target="_blank"
                >
                  <span className="btn-text">Register</span>
                  <span className="btn-icon">
                    <i className="feather-arrow-right"></i>
                  </span>
                </Link>
              </div> */}

              {(DateTime.fromISO(getMatchEvent.date.end) > DateTime.now()) && (
                <LinkButtonSliding text="Register Now" url={getMatchEvent.external_url} />
              )}
              <GoogleAdLarge />
              {(getMatchEvent.past_events && getMatchEvent.past_events.length > 0) ? (
                <PastEvents events={getMatchEvent.past_events} />
              ) : (
                <br />
              )}

              <DisqusComments blogType="event" blog={getMatchEvent} />

            </div>


            {/* <div className="rbt-feature-box rbt-shadow-box mt--60">
              <EventDescription getEventData={getMatchEvent} />
            </div>
            <EventFaq
              eventParentClass="rbt-accordion-style rbt-accordion-02 accordion mt--45"
              getEventData={getMatchEvent}
            />
            <div className="rbt-participants-area mt--60">
              <EventParticipants getEventData={getMatchEvent} />
            </div> */}

            {/* <br />
            <GoogleAdLarge /> */}

            <div className="related-course mt--60">
              <SimilarEvent getEventData={getMatchEvent} />
            </div>
          </div>
        </div>
        <div className="col-lg-4 mt_md--60 mt_sm--60">
          <div className="course-sidebar rbt-gradient-border sticky-top rbt-shadow-box course-sidebar-top">
            <EventViedo getEventData={getMatchEvent} />
          </div>
        </div>
      </div>
    </>
  );
};

export default EventDetails;
